import { BrowserRouter, Routes, Route } from "react-router-dom";
import Initial from "./components/Pages/Initial";
import Thanks from "./components/Pages/Thanks";
import AlreadyAnswred from "./components/Pages/AlreadyAnswred";
import NpsStore from "./components/Pages/NpsStore";
import AppStore from "./components/Pages/AppStore";
import RedirectHandler from "./components/Pages/RedirectHandler";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Initial></Initial>}></Route>
        <Route path="/npsStore" element={<NpsStore></NpsStore>}></Route>
        <Route path="/app-store" element={<AppStore></AppStore>}></Route>
        <Route path="/redirect-handler" element={<RedirectHandler></RedirectHandler>}></Route>
        <Route path="/thanks" element={<Thanks></Thanks>}></Route>
        <Route path="/alreadyAnswred" element={<AlreadyAnswred></AlreadyAnswred>}></Route>
      </Routes>
    </BrowserRouter>
  );
};
export default App;

